export const DailyReportPage = () => <main />;
